/**
 * Note: This ENUM is used as the mapping key for Maintenance table data from the Contentstack business database.
 * It's a unique key that used exclusively for website data handling and categorization.
 * */
export enum Category {
  TRUCK_4_WHEELS = 'truck-4-wheels',
  TRUCK_6_WHEELS = 'truck-6-wheels',
  TRUCK_6_WHEELS_MIDDLE = 'truck-6-wheels-middle',
  TRUCK_6_WHEELS_MIDDLE2 = 'truck-6-wheels-middle-2',
  TRUCK_6_WHEELS_LARGE = 'truck-6-wheels-large',
  TRUCK_10_WHEELS = 'truck-10-wheels',
  TRUCK_10_WHEELS_1_AXLE = 'truck-10-wheels-1-axle',
  TRUCK_10_WHEELS_2_AXLE = 'truck-10-wheels-2-axle',
  TRUCK_12_WHEELS = 'truck-12-wheels',
  TRUCK_TRACTOR = 'truck-tractor',
  TRUCK_TRACTOR_10_WHEELS = 'truck-tractor-10-wheels',
  TRUCK_TRACTOR_6_WHEELS = 'truck-tractor-6-wheels',
  TRUCK_MIXER = 'truck-mixer',
  TRUCK_MINIBUS_CHASSIS = 'truck-minibus-chassis',
  TRUCK_MINIBUS_CHASSIS2 = 'truck-minibus-chassis2',
}
